import { styled } from '@mui/material/styles';

const StyledButton = styled('button')`
  background-color: #4a9eff;
  color: white;
  border: none;
  border-radius: 24px;
  padding: 12px 40px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: block;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;

  &:hover {
    background-color: #3a8eef;
  }

  &:active {
    background-color: #2a7edf;
  }
`;

export default StyledButton;
